import React from 'react';
import dateFormat from 'dateformat';
import DatePicker from 'react-bootstrap-date-picker';

const composeDate = ({ date, hours, minutes }) => {
  const argh = new Date(date)
  argh.setHours(hours)
  argh.setMinutes(minutes)
  return argh
}

class DateField extends React.Component {

  componentWillMount() {
    console.log('date ', this.props.fieldContent)
    const date = new Date(this.props.fieldContent)
    this.setState({
      date: this.props.fieldContent,
      hours: date.getHours(),
      minutes: date.getMinutes(),
    })
  }

  inputChange = ({ date, hours, minutes }) =>
    this.setState((state) => ({
      date: date || state.date,
      hours: hours || state.hours,
      minutes: minutes || state.minutes,
    }), () => this.props.onChange(composeDate(this.state)))

  render() {
    let content = "";
    if (this.props.fieldContent)
      content = dateFormat(this.props.fieldContent, "dd/mm/yyyy HH:MM");

    return (
      <div>
        <div style={{display: 'flex',flexDirection:'row', paddingBottom:5, paddingTop:10, paddingLeft:20}}>
          <label>{this.props.fieldName} :</label>
          <div style={{paddingLeft:20}}>
            {!this.props.edit
              ? content
              : (
                <div>
                  <DatePicker
                    id="datePickerFrom"
                    value={this.state.date}
                    placeholder={this.props.placeholder}
                    onChange={(date) => this.inputChange({ date })}
                  />
                  <input
                    className="form-control"
                    value={this.state.hours}
                    type="Number"
                    min="0"
                    max="23"
                    style={styles.timeInput}
                    onChange={(e) => this.inputChange({ hours: e.target.value })}
                  /> :
                  <input
                    className="form-control"
                    value={this.state.minutes}
                    min="0"
                    max="59"
                    style={styles.timeInput}
                    onChange={(e) => this.inputChange({ minutes: e.target.value })}
                  />
                </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

DateField.propTypes = ({
  fieldName : React.PropTypes.string.isRequired,
  fieldContent : React.PropTypes.instanceOf(Date),
});

const styles = {
  timeInput: {
    maxWidth: 70,
    display: 'inline-block',
  }
}

export default DateField;



// WEBPACK FOOTER //
// ./src/components/DateField.js